<template>
  <div class="survey-end">
    <img :src="image" alt="mountain" class="order-1 order-lg-0" />

    <div class="content">
      <h1 class="mb-6 mb-lg-9">{{ greeting }}</h1>
      <h2 class="mb-6 mb-lg-7">
        Já temos o que precisamos para personalizar sua jornada!
      </h2>
      <p class="mb-lg-7">
        Agora é só colocar a mão na massa e começar a escalar o seu negócio
        digital na {{ $config.get("title") }}.
      </p>

      <div class="d-none d-lg-flex justify-content-start">
        <bp-button @click="$emit('advance')" label="Começar a escalar!" />
      </div>
      <bp-button
        label="Começar a escalar!"
        class="cta-button d-lg-none"
        @click="$emit('advance')"
      />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    greeting() {
      const name = this.$user.user?.name;
      const greeting = "Pronto! Obrigado" + (name ? ", " + name : "");
      return greeting;
    },
    image() {
      return window.innerWidth > 991
        ? require("@/assets/images/auth-after-register/climbers.png")
        : require("@/assets/images/auth-after-register/climbers-mobile.png");
    }
  }
};
</script>

<style lang="scss" scoped>
.survey-end {
  .content {
    @media screen and (min-width: 992px) {
      padding-left: 0;
    }
  }
}
</style>
